import { lazy } from 'react'

import { Loadable } from 'components'

import SubscriptionLayout from 'layout/SubscriptionLayout'
import AuthGuard from 'utils/route-guard/AuthGuard'

const Subscription = Loadable(lazy(() => import('pages/manage-subsription')))
const Upgrade = Loadable(lazy(() => import('pages/manage-upgrade')))

// ==============================|| AUTH ROUTING ||============================== //

const SubscriptionRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <SubscriptionLayout />
        </AuthGuard>
      ),
      children: [
        { path: 'subscription', element: <Subscription /> },
        { path: 'upgrade', element: <Upgrade /> },
      ],
    },
  ],
}

export default SubscriptionRoutes
